import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/index.jsx';
import Footer from '../../components/Footer/Footer.js';
import WaFloat from '../../components/WaFloat/WaFloat.jsx';
import { useReveal } from '../../hooks/useReveal.js';

const partnerTypes = [
  {
    type: 'Deal Sourcing Partner',
    h: 'Chartered Accountants & Business Advisors',
    p: 'You are close to promoters. You know before anyone when a business needs capital or strategic support. Refer the client to AQT Direct and we manage the advisory execution. You earn on every successful engagement.',
    earn: '15–25% of retainer + 20% of outcome fee',
  },
  {
    type: 'Investor Network Partner',
    h: 'Wealth Managers & Financial Advisors',
    p: "Your HNI and family office clients want curated, structured investment opportunities beyond listed markets. Connect them with AQT Direct's opportunities. We manage the process; you earn on capital connected.",
    earn: '1–1.5% of capital successfully connected',
  },
  {
    type: 'Regional Anchor Partner',
    h: 'Senior Bankers & Industry Leaders',
    p: 'One senior representative per city managing both advisory client sourcing and investor relationships. You become the AQT Direct presence in your region, supported by our platform and credibility.',
    earn: '₹25–50K monthly + regional engagement percentage',
  },
];

export default function Partners() {
  useReveal();
  return (
    <>
      <Navbar />

      <div className="page-hero about-hero">
        <div className="about-hero-wrap">
          <div className="page-hero-inner">
            <span className="sec-tag reveal">Partner Network</span>
            <h2 className="sec-h reveal" style={{ maxWidth: 560 }}>
              Grow with us.<br /><em>Earn with every engagement.</em>
            </h2>
            <p className="sec-sub reveal reveal-delay-1">
              We work with a select network of advisors, wealth professionals, and regional practitioners who bring business clients and investors to our platform.
            </p>
          </div>
          <div className="about-hero-img reveal reveal-delay-1">
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&q=80"
              alt="Financial partnership"
            />
          </div>
        </div>
      </div>

      <hr className="rule" />

      <section className="section section-off">
        <div className="partners-grid reveal" style={{ marginTop: 0 }}>
          {partnerTypes.map(({ type, h, p }) => (
            <div className="partner-tile" key={type}>
              <span className="pt-type">{type}</span>
              <h3>{h}</h3>
              <p>{p}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="cta-strip reveal">
        <h2>The right network<br /><em>creates the right opportunities.</em></h2>
        <p>If you believe your client base and network align with our advisory model, we invite a private conversation about partnership.</p>
        <div className="cta-btns">
          <Link className="btn-white" to="/contactus">Apply to Partner</Link>
        </div>
      </div>

      <Footer />
      <WaFloat />
    </>
  );
}
